export default __webpack_public_path__ + "static/media/mpm.e4583d9c.jpg";